import { SVGProps } from 'react';
const EmptyFolderIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
    >
        <path
            fillRule="evenodd"
            d="M2.5 3.5A.5.5 0 0 0 2 4v8a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5h-5v-.006a1.5 1.5 0 0 1-1.222-.86l-.42-.898a.5.5 0 0 0-.424-.236H2.5Zm3.5-1h.5v.001A1.5 1.5 0 0 1 7.552 3H13.5A1.5 1.5 0 0 1 15 4.5V12a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12V4a1.5 1.5 0 0 1 1.5-1.5H6ZM8.085 4l.099.211a.5.5 0 0 0 .453.289H13.5c.175 0 .344.03.5.085V4.5a.5.5 0 0 0-.5-.5H8.085Z"
            clipRule="evenodd"
        />
    </svg>
);
export default EmptyFolderIcon;
